import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Inventorys/LoadErpInventoryData',
    method: 'post',
    data
  });
}
